import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const RETREAT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/a9cb4b7b-e21a-4ce3-a72b-3395d02b709c.jpg';
export function Retreats() {
  return <section id="retreats" className="relative w-full overflow-hidden" data-id="element-114" data-mp="jfmbgb4z6ikh">
      <img src={RETREAT_IMAGE} alt="A hazy pale sunset over a calm open ocean, soft peach light on gentle seafoam water" className="absolute inset-0 h-full w-full object-cover" data-id="element-115" data-mp="jd8g016dv4ce" />
      <div className="absolute inset-0 bg-ink/45" aria-hidden="true" data-id="element-116" data-mp="5fbk76zr71ys" />

      <div className="relative mx-auto grid max-w-[1400px] gap-16 px-6 py-28 md:grid-cols-2 md:gap-20 md:px-10 md:py-40" data-id="element-117" data-mp="5fjtkowo3p58">
        <div data-id="element-118" data-mp="1ztcfxj00b8un">
          <Reveal data-id="element-119" data-mp="1zt2sa22fpds4">
            <SectionLabel align="left" tone="light" data-id="element-120" data-mp="1ztkrn7ke8849">
              Immerse Yourself
            </SectionLabel>
          </Reveal>

          <Reveal delay={0.08} data-id="element-121" data-mp="1uv16vahjd2dh">
            <span className="mt-6 inline-block text-[10px] font-light uppercase tracking-ultra text-white/75" data-id="element-122" data-mp="re6i2fhg0mxe">
              Retreats coming soon
            </span>
          </Reveal>

          <Reveal delay={0.14} data-id="element-123" data-mp="wb6poutxxxqm">
            <h2 className="mt-6 font-display text-4xl font-light leading-[1.15] text-white sm:text-5xl lg:text-[3.5rem]" data-id="element-124" data-mp="hgiklhsgd1bj">
              A community that
              <br data-id="element-125" data-mp="mfbwx6w06ma4" />
              <span className="italic" data-id="element-126" data-mp="mgws8yq56991">transforms</span>
            </h2>
          </Reveal>

          <Reveal delay={0.2} data-id="element-127" data-mp="1a70lcc5peqls">
            <p className="mt-7 max-w-prose text-[15px] font-light leading-[1.9] text-white/85" data-id="element-128" data-mp="1f4ai6cvfa4jn">
              Our first retreats are still being dreamed into being: sacred places where nature
              and practice intertwine. What already exists is the community: people who show up
              for each other, breathe together, and return to the natural world side by side.
            </p>
          </Reveal>

          <Reveal delay={0.26} data-id="element-129" data-mp="1xvae5y1c4emf">
            <p className="mt-5 max-w-prose text-[15px] font-light leading-[1.9] text-white/85" data-id="element-130" data-mp="1xvjusv0hp9fg">
              Gatherings closer to home are in the works too: sunrise flows, beach cleanups, days
              spent outside together. Join the community and you&rsquo;ll be the first to know when
              dates are announced.
            </p>
          </Reveal>

          <Reveal delay={0.32} data-id="element-131" data-mp="1tpemqnzg6wrn">
            <a href="#connect" className="group mt-10 inline-flex items-center gap-3 rounded-full border border-white/60 px-8 py-4 text-[10px] font-light uppercase tracking-ultra text-white transition-colors duration-500 hover:bg-white hover:text-ink" data-id="element-132" data-mp="1tq6ka4clv4kk">
              Get retreat announcements
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} aria-hidden="true" data-id="element-133" data-mp="1b08btn4wb9ge" />
            </a>
          </Reveal>
        </div>

        <div className="flex md:items-center md:justify-end md:pt-4" data-id="element-134" data-mp="112kf4rnqbrvl">
          <Reveal delay={0.16} className="w-full max-w-sm" data-id="element-135" data-mp="3co2u9obwftde">
            <div className="border-t border-white/25 pt-10 text-center" data-id="element-136" data-mp="3ho8rdk0xu82v">
              <h3 className="text-[11px] font-light uppercase tracking-ultra text-white/70" style={{
              textAlign: "right"
            }} data-id="element-137" data-mp="3hqbosp4f73hm">
                Upcoming community events
              </h3>
              <p className="mt-6 font-display text-3xl font-light italic leading-snug text-white sm:text-4xl" style={{
              textAlign: "right"
            }} data-id="element-138" data-mp="3qodmovsuxg0o">
                Coming soon…
              </p>
              <p className="mx-auto mt-5 max-w-xs text-[13px] font-light leading-relaxed text-white/70" style={{
              textAlign: "right"
            }} data-id="element-139" data-mp="2yyisakq57055">
                We’re planning our first gatherings now. Every one of them will be open to everyone, whatever your experience - just come as you are.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}